import { createApiSlice } from "@common";
import {
  CRUD_CONTACT_SOURCE,
  GET_CONTACT_SOURCE_BY_CONTACT_ID,
} from "@routes";

// 1 to 1
const apiConfig = [
  {
    name: "addContactSource",
    method: "post",
    url: CRUD_CONTACT_SOURCE,
    stateKey: "message",
  },
  {
    name: "getContactSourceByContactId",
    method: "get",
    url: GET_CONTACT_SOURCE_BY_CONTACT_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "contactSource",
  apiConfig,
  customReducers
);

const contactSourceSlice = slice;

export default contactSourceSlice.reducer;

export const {
  addContactSource,
  getContactSourceByContactId,
} = thunks;

export const { rowSelect, setAdditionalData } = actions;
